module.exports = __webpack_public_path__ + "img/Default_Avatar_Neutral@3x.56a2be99.png";